"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var zipCodeFormats_1 = __importDefault(require("../data/zipCodeFormats"));
var alphanumericZipCodeCountries = {};
var areZipCodesAlphanumeric = function (country) {
    var countryKey = '4HBu_' + country;
    var value = alphanumericZipCodeCountries[countryKey];
    if (typeof value === 'boolean' || value === null) {
        return value;
    }
    var info = zipCodeFormats_1.default[country];
    if (info && info.formats) {
        value = !!info.formats.some(function (format) { return format.indexOf('A') >= 0; });
    }
    else {
        value = null;
    }
    alphanumericZipCodeCountries[countryKey] = value;
    return value;
};
exports.default = areZipCodesAlphanumeric;
